var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZenusFinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Zenus_Bank_RGB_Turqoise",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.652,
    height: 22.429,
    viewBox: "0 0 156.652 22.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M225.361,37.9V54.364a1.98,1.98,0,0,1-1.985,1.979H216.11a2.294,2.294,0,0,1-2.292-2.292V37.89H208.39V55.132a5.145,5.145,0,0,0,5.145,5.145h12.109a5.145,5.145,0,0,0,5.145-5.145V37.89h-5.428Z",
    transform: "translate(-107.665 -37.878)",
    fill: "#00baff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M282.23,44.911V44.06a2.292,2.292,0,0,0-2.286-2.286h-6.964c-1.241,0-2.57.3-2.2,2.392.567,1.689,2.274,1.89,6.255,2.883,1.731.425,5.417,1.093,7.136,2.044a5.83,5.83,0,0,1,3.16,3.639,8.506,8.506,0,0,1,.3,2.321c0,.13-.012.254-.018.372a5.1,5.1,0,0,1-5.1,4.832H270.717a5.392,5.392,0,0,1-5.387-5.387V53.21h5.4v.851a2.292,2.292,0,0,0,2.286,2.286h6.964c1.24,0,2.818-.455,2.2-2.392-.567-1.689-2.233-1.548-6.214-2.534a30.237,30.237,0,0,1-7.177-2.386h-.012a5.856,5.856,0,0,1-3.154-3.639,8.506,8.506,0,0,1-.3-2.321c0-.13.012-.254.018-.372a5.1,5.1,0,0,1,5.1-4.832h11.784a5.385,5.385,0,0,1,5.387,5.387v1.66h-5.4Z",
    transform: "translate(-130.97 -37.87)",
    fill: "#00baff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M94.68,60.29V37.92h22.334v3.922H100.126v5.186H113.1v3.922H100.126v5.428h16.906V60.3H94.68Z",
    transform: "translate(-61.123 -37.89)",
    fill: "#00baff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M151.47,60.319V37.92h5.1l11.861,13.675V37.92h5.423v22.4h-5.1l-11.861-13.7v13.7Z",
    transform: "translate(-84.367 -37.89)",
    fill: "#00baff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M37.87,69.762v3.314H60.246V69.16H38.461Z",
    transform: "translate(-37.87 -50.677)",
    fill: "#00baff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M37.88,37.92v3.916H51.944L42.978,51h8.305l8.967-9.049V37.92Z",
    transform: "translate(-37.874 -37.89)",
    fill: "#00baff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenusFinBlue);
export default __webpack_public_path__ + "static/media/Zenus_Fin_Blue.ba7ec3aeb84c474c29af2eb9e94b02fd.svg";
export { ForwardRef as ReactComponent };